<template>
  <q-btn
    flat
    dense
    round
    :ripple="false"
    color="primary"
    size="18px"
    class="q-btn--hide-focus-helper m-shadow-helper"
  >
    {{ language }}
    <q-menu cover_ auto-close touch-position
      transition-show="scale"
      transition-hide="scale"
    >
      <q-list>
        <q-item clickable @click="handleSetLanguage('en')">
          <q-item-section>EN</q-item-section>
        </q-item>
        <q-item clickable @click="handleSetLanguage('nl')">
          <q-item-section>NL</q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </q-btn>
</template>

<script>
export default {
  name: 'LangSelector',
  computed: {
    language () {
      return this.$store.getters.language
    }
  },
  methods: {
    handleSetLanguage (lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
    }
  }
}
</script>
